import * as React from "react"

import { cn } from "@/lib/utils"

// Native date/time pickers: their calendar/clock icon.
const DATE_LIKE = new Set(["date", "datetime-local", "time", "month", "week"])

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    const dateLike = type != null && DATE_LIKE.has(type)
    return (
      <input
        type={type}
        // pointer-coarse: 44px on touch (docs/71 §63). Date/time fields pin
        // the picker icon to the field's right edge (Chromium otherwise draws
        // it right after the value, mid-field on a phone) and keep room for it
        // so a narrow field clips the value, never the icon.
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm pointer-coarse:min-h-11",
          dateLike &&
            "relative pr-9 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-3 [&::-webkit-calendar-picker-indicator]:top-1/2 [&::-webkit-calendar-picker-indicator]:m-0 [&::-webkit-calendar-picker-indicator]:-translate-y-1/2",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
